export default __webpack_public_path__ + "static/media/feather-file-plus.317eeff8.svg";